export default __webpack_public_path__ + "static/media/EmptyTeamRoster.d75985aa.svg";